import script from "./where-to.vue?vue&type=script&setup=true&lang=js"
export * from "./where-to.vue?vue&type=script&setup=true&lang=js"

import "./where-to.vue?vue&type=style&index=0&id=4c2a48a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c2a48a6"]])

export default __exports__